var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-line-container"},[_c('div',{staticClass:"flow-line",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }